import React, {useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import TextFieldSimple from "../../../textfield/TextFieldSimple";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";
import TextFieldValidation from "../../customer-detales/TextFieldValidation";

const ModalAddMaterialRetailIssuingEdge = ({
                                               open,
                                               onClose,
                                               titleModal,
                                               availability,
                                               issue,
                                               submit
                                           }) => {
    const [formState, setFormState] = useState({issue: issue})
    const [validationState, setValidationState] = useState({issue: ""})

    useEffect(() => {
        setFormState({issue: issue})
        setValidationState({issue: ""})
    }, [issue])

    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {

            if (value < 0) {
                newErrors[name] = "Значение меньше 0"
            }
        })

        setValidationState(newErrors)

        if (Object.values(newErrors).every(el => el === "")) {
            submit(formState.issue)
        }
    }

    return (
        <div>
            <Dialog open={open}>
                <DialogTitle textAlign="center">{titleModal}</DialogTitle>
                <DialogContent>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        '& > *': {
                            marginRight: '10px',
                        }
                    }}>
                        <TextFieldValidation
                            name={"availability"}
                            label={"Наличие"}
                            type={"number"}
                            value={availability}
                            width={"160px"}
                            disabled={true}
                        />
                        <TextFieldValidation
                            name={"issue"}
                            label={"Выдать"}
                            type={"number"}
                            value={formState?.issue}
                            setCurrValues={setFormState}
                            validationError={validationState?.issue}
                            setValidationState={setValidationState}
                            width={"160px"}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd
                        text={"Выдать"}
                        onClick={handleValidationData}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalAddMaterialRetailIssuingEdge;